import React from "react";
import HeaderDrawer from "../../../common/components/HeaderDrawer";
import UserList from "../../components/UserList";

const UserListScreen = (props) => {
  return (
    <HeaderDrawer name="Lista de usuários">
      <UserList isLoading={props.isLoading} getUsers={props.getUsers} onEditUser={(values) => props.editUser(values)}
        {...props} data={props.data} />
    </HeaderDrawer>
  );
};

export default UserListScreen;
